const getters = {
	isUserLoggedIn(state) {
		return state.isUserLoggedIn
	},
	getUserAuthInfo(state) {
		return state.userAuthInfo
	},
	getExpiry(state) {
		return state.expiry
	},
	isAuthModalOpen(state) {
		return state.isAuthModalOpen
	},
	getAuthModalTab(state) {
		return state.authModalTab
	},
	isAlertModalOpen(state) {
		return state.isAlertModalOpen
	},
	isLoginModalOpen(state) {
		return state.isLoginModalOpen
	},
	isLoginSelectionModalOpen(state) {
		return state.isLoginSelectionModalOpen
	},
	isSignupSelectionModalOpen(state) {
		return state.isSignupSelectionModalOpen
	},
	LoginSelectionMode(state) {
		return state.LoginSelectionMode
	},
	isForgetPasswordModalOpen(state) {
		return state.isForgetPasswordModalOpen
	}
}

export default getters
